<template lang="html">
  <div>
    <v-card
      v-for="(promise,i) in promises"
      :key="i"
      class="mt-3"
      flat
      :disabled="promise.is_rejected || promise.is_cancelled"
    >
      <v-list-item three-line>
        <v-list-item-avatar
          size="50"
          color="white"        
          class="mt-0"    
        >
          <v-img
            :src="promise.promiser.thumbnail_url"
          />
        </v-list-item-avatar>
        <v-list-item-content class="py-0 display-block">
          <v-list-item-title class="title mb-3">
            Promise with {{ promise.promiser.user.name }} 
            <span
              v-show="!promise.is_rejected && !promise.is_approved && !promise.is_cancelled"
              class="text-info body-2"
            >(Pending Approval) </span>

            <span
              v-show="promise.is_cancelled"
              class="text-danger body-2"
            >(Cancelled) </span>

            <span
              v-show="promise.is_rejected "
              class="text-danger body-2"
            >(Rejected) </span>

            <span
              v-show="promise.is_approved "
              class="text-success body-2"
            >(Approved) </span>

            <span
              class="body-2 text-danger"
            >| Due at: {{ $moment(promise.due_date, 'YYYY-MM-DD').format('D MMM YYYY') }}</span>
          </v-list-item-title>

          <p class="mb-1">
            Condition:
          </p>

          <p
            class="mb-3 text-justify"
            style="white-space: pre-line;"
          >
            {{ promise.conditions }}
          </p>
               
          <p class="mb-1">
            Promised:
          </p>

          <p
            class="text-success mb-3 text-justify"
            style="white-space: pre-line;"
          >
            {{ promise.promise }}
          </p>
        
          <p>
            Document: 
          </p>
          <span v-if="promise.documents.length>0">
            <v-chip
              v-for="document in promise.documents"
              :key="document.id"
              color="blue-grey lighten-3"
              small
              :href="document.file_url"
              target="_blank"
              class="mr-1"
            >
              <v-icon
                color="red"
                left
                small
              >
                mdi-file-pdf
              </v-icon>
              <span class="text-truncate"> {{ document.file_name }} </span>
            </v-chip>
          </span>

          <span v-else>N/A</span>

          <p class="disabled mt-2">
            Date Created:  {{ $moment(promise.created_at, 'YYYY-MM-DD').format('D MMM YYYY') }}
          </p>
        </v-list-item-content>
        <v-list-item-action class="mb-3">
          <employee-promises-dialog-cancel
            v-if="(!promise.is_rejected && !promise.is_approved &&!promise.is_cancelled ) && isMyProfile"
            :promise="promise"
            @cancelled="emitCancelled()"
          />
        </v-list-item-action>
      </v-list-item>
      <v-divider v-if="i+1 !==promises.length" />
    </v-card>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeePromisesDialogCancel: () => import('@/components/employee/promises/DialogCancel'),
    },
    props: {
      promises: {
        type: Array,
        default: () => {
          return []
        },
      },
    },
    computed: {
      isMyProfile () {
        return this.$store.state.isMyProfile
      },
    },
    methods: {
      emitCancelled () {
        this.$emit('cancelled')
      },
    },
  }
</script>

<style lang='css' scoped>
.text-truncate{
  white-space: nowrap; width:150px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.display-block{
  display: block;
}
</style>
